export const gtmPush = (category, action, label, data) => {
  if (process.env.RAZZLE_GTM_DEBUG) {
    console.log('[GTM]', { event: category, eventAction: action, eventLabel: label, ...(data && { data }) });
  }
  if (dataLayer) {
    let e = {
      event: category,
      eventAction: action,
      eventLabel: label
    };
    if (data) {
      e.data = data;
    }
    dataLayer.push(e);
  }
};
